import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UserInfoService } from '@ecap3/core';
import { TranslateService } from '@ngx-translate/core';
import { ModuleDMSConfig } from 'src/app/delta-config/constant/module-dms.constant';
import { IDmsConfig } from '../../interface/document.manager.interface';
import { DriveFolder } from '../../models/DriveFolder';
import { DocumentManagerService } from '../../services/document-manager.service';
import { DocumentNewFolderDialogComponent } from '../document-new-folder-dialog/document-new-folder-dialog.component';
import { DocumentShareDialogComponent } from '../document-share-dialog/document-share-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-document-folder-item',
    templateUrl: './document-folder-item.component.html',
    styleUrls: ['./document-folder-item.component.scss']
})
export class DocumentFolderItemComponent implements OnInit {
    constructor(
        private documentManagerService: DocumentManagerService,
        private snackBar: MatSnackBar,
        public dialog: MatDialog,
        private translateService: TranslateService,
        public userInfoService: UserInfoService
    ) {}
    canRemove: boolean = false;
    length: number;
    @Input() Folder: DriveFolder;
    @Input() Selected: boolean;
    @Input() dmsConfig: IDmsConfig;
    @Input() UserId: any;
    userInfo: any = {};
    colors = [
        '#69D2E7',
        '#A7DBDB',
        '#E0E4CC',
        '#F38630',
        '#FA6900',
        '#E94C6F',
        '#542733',
        '#5A6A62',
        '#C6D5CD',
        '#FDF200',
        '#DB3340',
        '#E8B71A',
        '#F7EAC8',
        '#1FDA9A',
        '#28ABE3',
        '#588C73',
        '#F2E394',
        '#F2AE72',
        '#D96459',
        '#8C4646',
        '#D0C91F',
        '#85C4B9',
        '#008BBA',
        '#E9514C',
        '#DC403B',
        '#00C8F8',
        '#59C4C5',
        '#FFC33C',
        '#FBE2B4',
        '#FF4C65'
    ];

    public Actions = {
        Share: () => {},
        Download: () => {},
        Remove: () => {}
    };
    forbiddenIdsToDelete = ModuleDMSConfig.forbiddenIdsToDelete;
    shareDocFeature = [
        {
            AppName: 'DMS',
            FeatureId: 'dms'
        }
    ];
    renameDocFeature = [
        {
            AppName: 'DMS',
            FeatureId: 'dms'
        }
    ];
    downloadDocFeature = [
        {
            AppName: 'DMS',
            FeatureId: 'dms'
        }
    ];
    deleteDocFeature = [
        {
            AppName: 'DMS',
            FeatureId: 'dms'
        }
    ];
    isPayrollDoc = false;
    ngOnInit() {
        this.isPayrollDoc =
            this.Folder.Description &&
            this.Folder.Description.indexOf('payroll_') == 0;
        if (this.dmsConfig.moduleFeatureId) {
            this.shareDocFeature = this.dmsConfig.features.shareDoc;
            this.renameDocFeature = this.dmsConfig.features.addDoc;
            this.deleteDocFeature = this.dmsConfig.features.deleteDoc;
            this.downloadDocFeature = [
                ...this.dmsConfig.features.addDoc,
                ...this.dmsConfig.features.deleteDoc,
                ...this.dmsConfig.features.shareDoc
            ];
        }
    }
    addOrRemoveFavourite(Folder) {
        let itemId: any;
        if (Folder.Name) {
            if (Folder.Type === 'SharedFolder') {
                itemId = Folder.OriginalObjectArtifactId;
            } else if (Folder.Type === 'DriveFolder') {
                itemId = Folder.ItemId;
            }
            this.documentManagerService.changeworkingState('busy');
            this.documentManagerService
                .AddOrRemoveFavorite(
                    itemId,
                    Folder.IsFavorite,
                    Folder.FileStorageId,
                    Folder.Type
                )
                .then(
                    (response) => {
                        this.documentManagerService.changeworkingState('idle');
                        if (
                            response.StatusCode === 0 ||
                            response.statusCode === 0
                        ) {
                            // this.matSnackBarOpen(
                            //     this.translateService.instant(
                            //         "APP_PLATFORM_DOCUMENT_MANAGER.DMS_FOLDER_RENAMED"
                            //     )
                            // );
                            this.documentManagerService.onFileRemove.next({
                                Status: true
                            });
                        } else {
                            this.matSnackBarOpen(
                                this.translateService.instant(
                                    'APP_PLATFORM_DOCUMENT_MANAGER.DMS_SOMETHING_WRONG_TRY_AGAIN'
                                )
                            );
                        }
                    },
                    (error) => {
                        this.documentManagerService.changeworkingState('idle');
                        this.matSnackBarOpen(
                            this.translateService.instant(
                                'APP_PLATFORM_DOCUMENT_MANAGER.DMS_SOMETHING_WRONG_TRY_AGAIN'
                            )
                        );
                    }
                );
        }
    }
    download(item) {
        this.documentManagerService.changeworkingState('busy');
        this.documentManagerService.downloadFile(item.FileStorageId).then(
            (response) => {
                this.documentManagerService.changeworkingState('idle');
                if (!response.Status) {
                    this.matSnackBarOpen(
                        this.translateService.instant(
                            'APP_PLATFORM_DOCUMENT_MANAGER.DMS_SOMETHING_WRONG_DOWNLOADING_FILE'
                        )
                    );
                }
            },
            (error) => {
                this.documentManagerService.changeworkingState('idle');
                this.matSnackBarOpen(
                    this.translateService.instant(
                        'APP_PLATFORM_DOCUMENT_MANAGER.DMS_SOMETHING_WRONG_DOWNLOADING_FILE'
                    )
                );
            }
        );
    }

    remove(item) {
        this.documentManagerService.changeworkingState('busy');
        this.documentManagerService
            .RemoveObject(
                item,
                item.OrganizationId,
                this.dmsConfig.actionOnShared
            )
            .then(
                (response) => {
                    this.documentManagerService.changeworkingState('idle');
                    if (
                        response.StatusCode === 0 ||
                        response.statusCode === 0
                    ) {
                        this.matSnackBarOpen(
                            this.translateService.instant(
                                'APP_PLATFORM_DOCUMENT_MANAGER.DMS_FOLDER_REMOVED'
                            )
                        );
                        this.documentManagerService.onFileRemove.next({
                            Status: true
                        });
                    }
                },
                (error) => {
                    this.documentManagerService.changeworkingState('idle');
                    this.matSnackBarOpen(
                        this.translateService.instant(
                            'APP_PLATFORM_DOCUMENT_MANAGER.DMS_SOMETHING_WRONG_TRY_AGAIN'
                        )
                    );
                }
            );
    }

    changeColor(color, Folder) {
        this.documentManagerService.changeworkingState('busy');
        this.documentManagerService
            .ChangeFolderColor(Folder['ItemId'], color)
            .then(
                (response) => {
                    this.documentManagerService.changeworkingState('idle');
                    this.Folder.Color = color;
                },
                (error) => {
                    this.documentManagerService.changeworkingState('idle');
                    this.matSnackBarOpen(
                        this.translateService.instant(
                            'APP_PLATFORM_DOCUMENT_MANAGER.DMS_SOMETHING_WRONG_TRY_AGAIN'
                        )
                    );
                }
            );
    }

    rename(Folder) {
        const dialogRef = this.dialog.open(DocumentNewFolderDialogComponent, {
            width: '500px',
            data: {
                purpose: 'rename',
                folderNameMinLength: 1,
                title: 'Rename Folder',
                LanguageKey: 'APP_PLATFORM_DOCUMENT_MANAGER.DMS_RENAME_FOLDER',
                name: Folder.Name
            },
            disableClose: false
        });
        dialogRef.afterClosed().subscribe((FolderName) => {
            let itemId: any;
            if (FolderName && FolderName.length > 0) {
                if (Folder.Type === 'SharedFolder') {
                    itemId = Folder.OriginalObjectArtifactId;
                } else if (Folder.Type === 'DriveFolder') {
                    itemId = Folder.ItemId;
                }
                this.documentManagerService.changeworkingState('busy');
                if (this.dmsConfig.ModuleWorkspaceId) {
                    itemId = Folder.ItemId;
                    Folder.Type = 'DriveFolder';
                }
                this.documentManagerService
                    .RenameObject(
                        itemId,
                        FolderName,
                        Folder.FileStorageId,
                        Folder.Type
                    )
                    .then(
                        (response) => {
                            this.documentManagerService.changeworkingState(
                                'idle'
                            );
                            if (
                                response.StatusCode === 0 ||
                                response.statusCode === 0
                            ) {
                                this.matSnackBarOpen(
                                    this.translateService.instant(
                                        'APP_PLATFORM_DOCUMENT_MANAGER.DMS_FOLDER_RENAMED'
                                    )
                                );
                                this.documentManagerService.onFileRemove.next({
                                    Status: true
                                });
                            } else {
                                this.matSnackBarOpen(
                                    this.translateService.instant(
                                        'APP_PLATFORM_DOCUMENT_MANAGER.DMS_SOMETHING_WRONG_TRY_AGAIN'
                                    )
                                );
                            }
                        },
                        (error) => {
                            this.documentManagerService.changeworkingState(
                                'idle'
                            );
                            this.matSnackBarOpen(
                                this.translateService.instant(
                                    'APP_PLATFORM_DOCUMENT_MANAGER.DMS_SOMETHING_WRONG_TRY_AGAIN'
                                )
                            );
                        }
                    );
            }
        });
    }

    share(Folder) {
        this.documentManagerService.documentShareEvent.emit({
            folder: Folder,
            type: 'Folder'
        });
        const dialogRef = this.dialog.open(DocumentShareDialogComponent, {
            width: '600px',
            // height:'600px',
            data: {
                Folder: Folder,
                Type: 'Folder',
                dmsConfig: this.dmsConfig
            },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((resp) => {
            if (!resp.canceled) {
                if (resp.success) {
                    this.documentManagerService.changeworkingState('idle');
                    this.snackBar.open(
                        this.translateService.instant(
                            'APP_PLATFORM_DOCUMENT_MANAGER.DMS_FOLDER_SHARED'
                        ),
                        null,
                        {
                            duration: 3000
                        }
                    );
                } else {
                    this.documentManagerService.changeworkingState('idle');
                    this.snackBar.open(
                        this.translateService.instant(
                            'APP_PLATFORM_DOCUMENT_MANAGER.DMS_SOMETHING_WRONG_TRY_AGAIN'
                        ),
                        null,
                        {
                            duration: 3000
                        }
                    );
                }
            }
        });
    }
    matSnackBarOpen(value, duration?: number) {
        const translateValue = this.translateService.instant(value);
        this.snackBar.open(translateValue, null, {
            duration: duration || 3000,
            verticalPosition: 'top',
            horizontalPosition: 'end',
            panelClass: 'custom-snackbar'
        });
    }
    archive(folder) {
        this.documentManagerService.changeworkingState('busy');
        this.documentManagerService
            .AddOrRemoveFromArchive(folder.ItemId, true)
            .then((resp) => {
                this.documentManagerService.onFileRemove.next({
                    Status: true
                });
                console.log(resp);
            });
    }
    unarchive(folder) {
        this.documentManagerService.changeworkingState('busy');
        this.documentManagerService
            .AddOrRemoveFromArchive(folder.ItemId, false)
            .then((resp) => {
                this.documentManagerService.onFileRemove.next({
                    Status: true
                });
                console.log(resp);
            });
    }
}
